// tslint:disable: no-implicit-dependencies
import { LinkButton } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { useIsMobileDevice } from '../../../hooks';
import * as styles from './styles.module.css';
const success = require('!url-loader!./assets/success.png');
const imgDesktop = require('!url-loader!./assets/desktop.svg');
const imgMoble = require('!url-loader!./assets/mobile.svg');

export const CandidateSuccessScreen = () => {
  const isMobile = useIsMobileDevice();

  return (
    <div
      {...mergeStyles(
        styles['container'],
        isMobile && styles['container-mobile'],
      )}
    >
      <img
        className={styles['success-icon']}
        src={success}
        width={64}
        height={72}
      />
      <div
        {...mergeStyles(styles['title'], isMobile && styles['title-mobile'])}
      >
        Готовим объявление к публикации.
        <br />
        Что будет дальше?
      </div>
      <div
        {...mergeStyles(styles['scroll'], isMobile && styles['scroll-mobile'])}
      >
        <div>
          {isMobile ? (
            <img className={styles['img-mobile']} src={imgMoble} />
          ) : (
            <img className={styles['img-desktop']} src={imgDesktop} />
          )}
        </div>
        <div
          {...mergeStyles(styles['list'], isMobile && styles['list-mobile'])}
        >
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
            )}
          >
            <div className={styles['item-title']}>Модерация объявления</div>
            <div className={styles['item-description']}>
              Мы проверим ваше объявление и опубликуем его в течение 2 часов.
              Если что-то пойдёт не так – свяжемся с вами по смс.
            </div>
          </div>
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
            )}
          >
            <div className={styles['item-title']}>Активируйте сервис</div>
            <div className={styles['item-description']}>
              После публикации необходимо заполнить данные в Личном кабинете,
              чтобы активировать все функции сервиса. Весь процесс займёт не
              более получаса.
            </div>
          </div>
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
            )}
          >
            <div className={styles['item-title']}>
              Выберите идеального жильца и заключите договор
            </div>
            <div className={styles['item-description']}>
              Выбирайте арендаторов из анкет в Личном кабинете и проверяйте их
              надёжность. После показа квартиры заключите безопасный договор
              аренды онлайн с помощью смс.
            </div>
          </div>
          <div
            {...mergeStyles(
              styles['item-content'],
              isMobile && styles['item-content-mobile'],
            )}
          >
            <div className={styles['item-title']}>Сдавайте без забот!</div>
            <div className={styles['item-description']}>
              Заходите на сайт только для оплаты налога и заполнения суммы по
              счётчикам, а мы будем напоминать арендатору об оплате аренды.
            </div>
            <div className={styles['item-button']}>
              <LinkButton fullWidth size="M" href="https://my.cian.ru/">
                Личный кабинет
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
